import { withAuth } from 'hocs/auth/with-auth';
import { LayoutType, withLayout } from 'hocs/with-layout';
import { VaultImport } from './vault-import';

const WrapAuth = withAuth(VaultImport);
// Renders the vault top bar itself, like the other vault screens.
const WrappedVaultImport = withLayout(LayoutType.Empty, WrapAuth);

export { WrappedVaultImport as VaultImport };
